export abstract class ResourceModel<T> {
  public id?: number;

  constructor(model?: Partial<T>) {
    if (model) {
      Object.assign(this, model);
    }
  }

  public toJson(): any {
    return JSON.parse(JSON.stringify(this));
  }
}

export interface Paginated<T> {
  pagination: Pagination;
  body: T[];
}

export class Pagination {
  public TotalCount: number;
  public PageSize: number;
  public CurrentPage: number;
  public TotalPages: number;
  public HasNext: boolean;
  public HasPrevious: boolean
}

export interface PaginationParams {
  PageNumber?: number | undefined;
  PageSize?: number | undefined;
  OrderBy?: string | undefined;
  Fields?: string | undefined;
  IncludeEntities?: string | undefined;
  SearchTerm?: string | undefined;
  IncludeSearch?: string | undefined;
}

export interface DataTable {
  fields: string[];
  headerRow: string[];
  dataRows: any[];
  pagination: Pagination;
}


export enum NotificationType {
  default = 0,
  info = 1,
  success = 2,
  warning = 3,
  danger = 4,
  rose = 5,
  primary = 6
}

export enum VerticalPosition {
  bottom = "bottom",
  top = "top"
}

export enum HorizontalPosition {
  left = "left",
  center = "center",
  right = "right"
}


export enum MaterialInputAppearance {
  legacy = "legacy",
  standard = "standard",
  fill = "fill",
  outline = "outline"
}

export enum EntityRFC {
  Shelter = "Shelter",
  Supplier = "Supplier"
}